import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import { Virtuoso } from "react-virtuoso";
import { v4 } from "uuid";
import { selectCanEditCustomers } from "../redux/auth";
import {
  edit as editCustomer,
  selectors as customerSelectors,
} from "../redux/customers";
import {
  selectors as gdsSelectors,
  selectGdsIdsByCustomerIdMap,
} from "../redux/gds";
import CustomerRow from "./CustomerRow";

const Customers = (props) => {
  const dispatch = useDispatch();

  const canEditCustomers = useSelector(selectCanEditCustomers);

  const onAddNewClick = () => {
    dispatch(editCustomer({ id: v4(), isNew: true }));
  };

  const customers = useSelector(customerSelectors.selectAll);

  const gdsOfficesByCustomerId = useSelector(selectGdsIdsByCustomerIdMap);
  const gdsOffices = useSelector(gdsSelectors.selectEntities);

  return (
    <Box className={props.className}>
      <Paper elevation={1}>
        <Grid container xs={12} spacing={0} className="header">
          <Grid xs={1} sm={0.5}></Grid>
          <Grid xs={8} sm={4} md={3}>
            Name
          </Grid>
          <Grid xs={3} sm={1.5}>
            Service Fee
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={3}>
            GDS IDs
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={3} md={2}>
            Saved At
          </Grid>
          <Grid display={{ xs: "none", md: "block" }} md={2}>
            Saved By
          </Grid>
        </Grid>
      </Paper>
      <Virtuoso
        data={customers}
        itemContent={(index, customer) => (
          <CustomerRow
            canEdit={canEditCustomers}
            key={customer.id}
            customer={customer}
            gdsOffices={(gdsOfficesByCustomerId[customer.id] || []).map(
              (id) => gdsOffices[id]?.officeId,
            )}
          />
        )}
        increaseViewportBy={200}
        style={{ height: "calc(100vh - 104px)" }}
      />
      {canEditCustomers && (
        <Fab className="AddNewButton" onClick={onAddNewClick}>
          <AddIcon />
        </Fab>
      )}
    </Box>
  );
};

export default styled(Customers)(
  ({ theme }) => `
  .header {
    font-family: notosans-regular;
    font-weight: 400;
    padding: 12px 40px 12px 16px;
    background-color: ${theme.palette.header.main};
  }

  .MuiGrid2-root {
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .AddNewButton {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
`,
);
